module.exports = __webpack_public_path__ + "static/kieszonkowe-5998baada65368096b4df575ccb2dfd0.jpg";